export default __webpack_public_path__ + "static/media/Wizenbone.ee416012.jpg";